<template>
  <div class="">



    <div class="d-flex justify-center mt-5 mb-2">
      <v-sheet class="">

        <div class="d-flex justify-start" style="height: 40px;">
          <img class="ma-1 pa-0" height="30px" :src="icon">
          <p class="ml-1 pa-0" style="font-size: 26px; font-weight:400;">
            {{ name }}
          </p>
        </div>

        <div style="width: 600px;" class="pr-3">
          <v-carousel :show-arrows="false" touchless continuous cycle class="p0 m0 my-0 py-0" height="400">
            <v-carousel-item v-for="(img, index) in images" v-bind:key="games" :src="img" width="600px" cover>
            </v-carousel-item>
          </v-carousel>
        </div>
      </v-sheet>

      <v-sheet class="" width="320px">
        <div class="" style="height: 40px;"></div>
        <img class="game_header_image_full" :src="capsule" width="320px">
        <v-sheet class="" width="310px">
          <div class="">
            <p class="text" style="height: 150px;">Embrace the role of Thoria's ultimate Mediator.
               In this gripping Action Roguelite, unlock diverse classes, harness thousands of spell combinations, and face epic boss battles.
               How long can you survive the endless enemy horde for?</p>
            <p class="text" style="height: 25px;">RELEASE DATE: 12 Jan, 2024</p>
            <div class="d-flex justify-start">
              <v-chip x-small class="mr-1 pt-3 pb-3" label color="orange">Fantasy</v-chip>
              <v-chip x-small class="ml-1 mr-1 pt-3 pb-3" label color="orange">Roguelike</v-chip>
              <v-chip x-small class="ml-1 mr-1 pt-3 pb-3" label color="orange">Survivors</v-chip>
              <v-chip x-small class="ml-1 mr-1 pt-3 pb-3" label color="orange">VS</v-chip>
            </div>
          </div>
        </v-sheet>
      </v-sheet>
    </div>


    <div class="d-flex justify-center mb-2">
      <v-sheet color="primary pa-2 ma-0" width="920px" height="58px">
        <v-btn width="180px" height="40px" color="secondary"
          @click="openInNewTab('https://store.steampowered.com/app/2540810')" class="">
          <v-icon class="mr-1">mdi-steam</v-icon>Play Now
        </v-btn></v-sheet>
    </div>

    <div class="d-flex justify-center mb-2">
      <v-sheet class="" width="920px">

        <div class="d-flex justify-center mt-2">
          <iframe style="border-width: 0;" class="embed-responsive-item" src="https://www.youtube.com/embed/Phciovuc5OE" width=872px height=491px
            allowfullscreen>
          </iframe>
        </div>

        <p class="px-5 pt-5">Embark on an epic journey with Nyran Survivors, an action-packed roguelite where you'll confront endless hordes of foes and take on formidable bosses.
           Unleash powerful skills, evolve your character and master ancient spells. Earn spoils from each battle to unlock new classes, upgrade your abilities, and forge a path to become the ultimate Mediator.</p>

        <div class="d-flex justify-center mb-4">
          <img src="https://store.steampowered.com/gfxproxy/betagfx/apps/2540810/extras/Classes.gif?t=1708988532">
        </div>

        <p class="px-5">Choose your path from an array of distinct classes, each offering unparalleled abilities.
           Play up to 10 classes with more on the horizon over 2 game modes.
        </p>

        <div class="d-flex justify-center mb-4">
          <img src="https://store.steampowered.com/gfxproxy/betagfx/apps/2540810/extras/Items.gif?t=1708988532">
        </div>

        <p class="px-5">Over 80 items for you to equip with more along the way.
        </p>

        <div class="d-flex justify-center mb-4">
          <img src="https://store.steampowered.com/gfxproxy/betagfx/apps/2540810/extras/Spells1.gif?t=1708988532">
        </div>

        <p class="px-5">Nyran Survivors has over 100 unique spells and abilities for you to collect and master with more to come!
        </p>

        <div class="d-flex justify-center mb-4">
          <img src="https://store.steampowered.com/gfxproxy/betagfx/apps/2540810/extras/Bosses.gif?t=1708988532">
        </div>

        <p class="px-5">6 unique bosses per map for you to defeat for a total of 30 bosses.
        </p>

        <div class="d-flex justify-center mb-4">
          <img src="https://store.steampowered.com/gfxproxy/betagfx/apps/2540810/extras/Upgrade.gif?t=1708988532">
        </div>

        <p class="px-5">Upgrade your class through 40 levels.</p>

        <div class="d-flex justify-center mb-4">
          <img src="https://store.steampowered.com/gfxproxy/betagfx/apps/2540810/extras/Passives.gif?t=1708988532">
        </div>

        <p class="px-5">Select from a variety of 12 distinct passives to enhance your abilities throughout the battle, with the option to have 3 active simultaneously.
        </p>

        <h3 class="px-5">Leaderboards</h3>
        <p class="px-5">Can you secure the top spot and become a true legend? Let your name shine on the global stage of Nyran Survivors! The game lists the top 100 players' rating per map.
        <br/>
        <br/>
        <i>* uses a logged in Discord account</i></p>
      </v-sheet>
    </div>

    <div class="d-flex justify-center mb-5">
      <v-sheet class="" width="920px">
        <p class="mx-3 mt-3">Need support for {{ name }}? Join our Discord <a href="https://discord.gg/UcKJdYb4dt" target="_blank">here</a></p>
      </v-sheet>
    </div>

  </div>
</template>

<script>
export default {
  name: 'Home',
  metaInfo: {
    title: 'Diminished Studios - Nyran Survivors',
    titleTemplate: '%s',
    htmlAttrs: {
      lang: 'en-US'
    },
    meta: [
      { charset: 'utf-8' },
      { name: 'description', content: "Embrace the role of Thoria's ultimate Mediator in this survivors like action roguelike" },
      { name: 'viewport', content: 'width=device-width, initial-scale=1' },
      { property: 'og:title', content: 'Diminished Studios - Nyran Survivors' },
      { property: 'og:image', content:'https://i.imgur.com/lVLowgo.png'}
    ]
  },
  data: () => ({
    name: 'Nyran Survivors', icon: "https://cdn.cloudflare.steamstatic.com/steamcommunity/public/images/apps/2540810/0a44260944cb4772247fb47c4ca98e7089f19ff8.jpg", capsule: "https://store.steampowered.com/gfxproxy/betagfx/apps/2540810/header.jpg?t=1708988532",
    images: ["https://store.steampowered.com/gfxproxy/betagfx/apps/2540810/ss_011f87a399cd1d52c7944ab53610884a2feaa49d.600x338.jpg?t=1708988532",
      "https://store.steampowered.com/gfxproxy/betagfx/apps/2540810/ss_c174b53ac3a162f7405134adc95ee24feda8e374.600x338.jpg?t=1708988532",
      "https://store.steampowered.com/gfxproxy/betagfx/apps/2540810/ss_f88f9bf1f957052481eca3c06fc4ccf8bbed36c0.600x338.jpg?t=1708988532",
      "https://store.steampowered.com/gfxproxy/betagfx/apps/2540810/ss_02a839697227b56b0f9c5c2f21e8ce5f72f7bb63.600x338.jpg?t=1708988532",
      "https://store.steampowered.com/gfxproxy/betagfx/apps/2540810/ss_9b7fd60639c1fa67ec1dfa53fdc3343c00166d64.600x338.jpg?t=1708988532",
      "https://store.steampowered.com/gfxproxy/betagfx/apps/2540810/ss_eb3c3a9519cc84759c36489b4f066bac4de2b8c1.600x338.jpg?t=1708988532",
      "https://store.steampowered.com/gfxproxy/betagfx/apps/2540810/ss_2c379fbc0301803a52ab583fc71cef3f289eeeb0.600x338.jpg?t=1708988532",
      "https://store.steampowered.com/gfxproxy/betagfx/apps/2540810/ss_9142a53cc943ac5dac24740131622b9cea44be6f.600x338.jpg?t=1708988532"
]
  }),
  methods: {
    openInNewTab(url) {
      window.open(url, '_blank', 'noreferrer');
    },
  },
}
</script>

<style>
.v-image {
  .v-image__image {
    transition: all 0.4s;
  }

  &.zoom {
    .v-image__image {
      transform: scale(1.1);
    }
  }
}

.text {
  font-size: 13px;
  text-align: left;
}

.homepagecard {
  font-size: 16px;
  font-weight: bolder;
}

.homepagecarddesc {
  font-size: 14px;
}

.video {
  background-color: #181818;
  width: 100%;
}</style>
